'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _cbTabs = require('./cb-tabs.directive');

var _cbTabs2 = _interopRequireDefault(_cbTabs);

var _cbTabs3 = require('./cb-tabs.controller');

var _cbTabs4 = _interopRequireDefault(_cbTabs3);

var _cbTab = require('./cb-tab.directive');

var _cbTab2 = _interopRequireDefault(_cbTab);

var _cbTab3 = require('./cb-tab.controller');

var _cbTab4 = _interopRequireDefault(_cbTab3);

var _cbTabPane = require('./cb-tab-pane.directive');

var _cbTabPane2 = _interopRequireDefault(_cbTabPane);

var _cbTabPane3 = require('./cb-tab-pane.controller');

var _cbTabPane4 = _interopRequireDefault(_cbTabPane3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* cb-tabs
 *
 * This is a layout-agnostic directive which provides tabbing functionality.
 * It is used in conjunction with `cb-tab` (the buttons) and `cb-tab-pane`
 * (the tab content).  Characteristic to tabs is that only one tab pane can be
 * open (active) at the same time.
 *
 * `cb-tab` exposes a `tab.setActive()` function (which can be used in
 * `ng-click` or `ng-mouseover`).  Pass a unique ID to the directive, e.g.
 * `<li cb-tab="tab1"></li>`; this ID corresponds to the tab pane with the
 * same ID.
 *
 * `cb-tab-pane` exposes a `tabPane.isActive()` function (which can be used in
 * `ng-show` or `ng-if`).  Pass the same ID as the one used by `cb-tab`, e.g.
 * `<div cb-tab-pane="tab1"></div>`.
 *
 * Multiple `cb-tabs` components can coexist on a page, and IDs can be reused
 * across them, but inside a `cb-tabs` component, each ID must be unique.
 *
 * Example setup:
 *
 * <div cb-tabs>
 *     <ul>
 *         <li cb-tab="tab1"><a ng-click="tab.setActive()">Tab 1</a></li>
 *         <li cb-tab="tab2"><a ng-click="tab.setActive()">Tab 2</a></li>
 *         <li cb-tab="tab3"><a ng-click="tab.setActive()">Tab 3</a></li>
 *     </ul>
 *     <div cb-tab-pane="tab1" ng-show="tabPane.isActive()">Tab 1 content</div>
 *     <div cb-tab-pane="tab2" ng-show="tabPane.isActive()">Tab 2 content</div>
 *     <div cb-tab-pane="tab3" ng-show="tabPane.isActive()">Tab 3 content</div>
 * </div>
 */
var _module = _angular2.default.module('cb.ui-components.tabs', [_cbTabs2.default.name, _cbTabs4.default.name, _cbTab2.default.name, _cbTab4.default.name, _cbTabPane2.default.name, _cbTabPane4.default.name]);

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/tabs/index.js
// module id = 920
// module chunks = 0